import { render, staticRenderFns } from "./min-editor.vue?vue&type=template&id=2ff8c165&scoped=true"
import script from "./min-editor.vue?vue&type=script&lang=js"
export * from "./min-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8c165",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff8c165')) {
      api.createRecord('2ff8c165', component.options)
    } else {
      api.reload('2ff8c165', component.options)
    }
    module.hot.accept("./min-editor.vue?vue&type=template&id=2ff8c165&scoped=true", function () {
      api.rerender('2ff8c165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/min-editor.vue"
export default component.exports